import axios from 'axios'
import _ from 'underscore'
const state = {
  forms: {},
  availableForms: {},
  formsElements: {}
}
const mutations = {
  SET_AVAILABLE_FORMS: function (state, payload) {
    state.availableForms = payload
  },
  SET_FORM: function (state, payload) {
    state.forms = { ...state.forms, [payload.formName]: payload.form }
  },
  SET_FORM_ELEMENTS: function (state, payload) {
    state.formsElements = {
      ...state.formsElements,
      [payload.formName]: payload.elements
    }
  }
}

const actions = {
  getSectionsWithParams ({ commit, state, getters }, payload) {
    return new Promise((resolve, reject) => {
      const convertId = {
        $addFields: { id: { $toString: '$_id' } }
      }
      let aggregate = []
      _.each(payload.pipeLine, stage => aggregate.push(stage))
      aggregate.push(convertId)
      axios
        .post('/api/data/pageSections/get', { aggregate })
        .then(rslt => {
          resolve(rslt)
        })
        .catch(err => reject(err))
    })
  },
  getSectionsInPage ({ commit, state, getters }, payload) {
    return new Promise((resolve, reject) => {
      const convertId = {
        $addFields: { id: { $toString: '$_id' } }
      }
      const aggregate = [{ $match: { page: payload.pageName } }, convertId]
      axios
        .post('/api/data/pageSections/get', { aggregate })
        .then(rslt => {
          resolve(rslt)
        })
        .catch(err => reject(err))
    })
  },
  getAvailablesForm ({ commit, state, getters }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/V2/forms/availables/pageSection')
        .then(rslt => {
          commit('SET_AVAILABLE_FORMS', rslt.data)
          resolve(rslt)
        })
        .catch(err => reject(err))
    })
  },
  getSectionForm ({ commit, state, getters }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/V2/forms/get/' + payload.name)
        .then(rslt => {
          commit('SET_FORM', { formName: payload.name, form: rslt.data })
          resolve(rslt)
        })
        .catch(err => reject(err))
    })
  },
  getSectionData ({ commit, state, getters }, payload) {
    return new Promise((resolve, reject) => {
      const matchPipe = {
        $addFields: { id: { $toString: '$_id' } }
      }
      const aggregate = [matchPipe, { $match: { id: payload.id } }]
      axios
        .post(`/api/data/${payload.dataType}s/get/${payload.id}`, {
          aggregate
        })
        .then(rslt => {
          // commit('SET_FORM', { formName: payload.name, form: rslt.data })
          resolve(rslt)
        })
        .catch(err => reject(err))
    })
  },
  getSectionElements ({ commit, state, getters }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`api/data/${payload.type}s/get`, {
          // query: { parent: payload.parent || null },
          aggregate: [
            { $match: { parent: payload.parent || null } },
            { $addFields: { id: { $toString: '$_id' } } }
          ],
          filters: {
            sort: { created: 1 }
          }
        })
        .then(response => {
          commit('SET_FORM_ELEMENTS', {
            formName: payload.name,
            elements: response.data
          })
          resolve(response)
        })
        .catch(err => reject(err))
    })
  }
}

const getters = {
  formsFileFields: state => {
    return _.mapObject(state.forms, form =>
      _.chain(form.fields)
        .filter(field => field.type === 'file')
        .pluck('name')
        .value()
    )
  },
  availableFormsName: state => {
    return _.pluck(state.availableForms, 'name')
  },
  elementsIds: state => {
    return _.mapObject(state.formsElements, elements =>
      _.chain(elements)
        // .filter(field => field.type === 'file')
        .pluck('id')
        .value()
    )
  }
}

export default { state, getters, mutations, actions }
